import { LILAC_500, tokens } from '@airtel/air-design-system';
import { Dimensions, StyleSheet } from 'react-native';
export var getButtonWidgetStyles = props => {
  var _props$direction = props.direction,
    flexDirection = _props$direction === void 0 ? 'column' : _props$direction,
    containerBackgroundColor = props.containerBackgroundColor,
    showBorderTop = props.showBorderTop,
    borderTopColor = props.borderTopColor,
    _props$buttonAlignmen = props.buttonAlignment,
    buttonAlignment = _props$buttonAlignmen === void 0 ? 'center' : _props$buttonAlignmen,
    leftCta = props.leftCta,
    rightCta = props.rightCta,
    showBorderTopAsFullWidth = props.showBorderTopAsFullWidth;
  var version = leftCta.version;
  var rightCtaVersion = rightCta.version;
  var isRow = flexDirection === 'row';
  var isColumn = flexDirection === 'column';
  var isRowReverse = flexDirection === 'row-reverse';
  var isColumnReverse = flexDirection === 'column-reverse';
  var spacing = tokens.spacing;
  var _Dimensions$get = Dimensions.get('window'),
    screenWidth = _Dimensions$get.width;
  var isOnlyRow = isRow || isRowReverse;
  return StyleSheet.create({
    container: Object.assign(Object.assign({
      display: 'flex',
      flexDirection,
      justifyContent: !isOnlyRow ? 'center' : buttonAlignment,
      alignItems: isOnlyRow ? 'center' : buttonAlignment,
      paddingHorizontal: containerBackgroundColor ? spacing.SPACING_20 : spacing.SPACING_0,
      paddingVertical: containerBackgroundColor ? spacing.SPACING_16 : spacing.SPACING_0,
      backgroundColor: containerBackgroundColor
    }, showBorderTop && {
      borderTopColor: borderTopColor || LILAC_500,
      borderTopWidth: 1
    }), showBorderTopAsFullWidth && {
      width: screenWidth
    }),
    button: Object.assign({}, (isRow || isRowReverse) && buttonAlignment === 'center' && {
      flex: 1
    }),
    leftButton: Object.assign(Object.assign(Object.assign({}, version === 'variable-width' && (isColumn || isColumnReverse || !rightCta.title) && {
      width: '100%'
    }), isRowReverse && !!rightCta.title && {
      marginLeft: spacing.SPACING_16
    }), isColumnReverse && !!rightCta.title && {
      marginTop: spacing.SPACING_16
    }),
    rightButton: Object.assign(Object.assign(Object.assign({}, rightCtaVersion === 'variable-width' && (isColumn || isColumnReverse || !leftCta.title) && {
      width: '100%'
    }), isRow && !!leftCta.title && {
      marginLeft: spacing.SPACING_16
    }), isColumn && !!leftCta.title && {
      marginTop: spacing.SPACING_16
    }),
    checkBox: {
      marginBottom: spacing.SPACING_20
    },
    priceBreakupContainer: {
      marginBottom: spacing.SPACING_4
    },
    dividerStyle: {
      position: 'absolute'
    }
  });
};
export var getWrapperStyles = () => {
  return StyleSheet.create({
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start'
    }
  });
};